import { Injectable } from "@angular/core";
import { IFeatures } from "../../_models/features";
import { environment } from "../../../environments/environment";
import { LocalStorageManagerService } from "../localStoageManager.service";
import { UserPermissions } from "../../_models/user/user-permissions";
import { CalculateUSerPermissionFromUser } from "./session-manager.user-premission";
import { GenericUser } from "../../_models";

@Injectable()
export class SessionManagerService {
  private _user: GenericUser | null = null;
  private readonly devToolsEnabled: boolean = false;
  private readonly isLocalHost: boolean = false;
  constructor(private localStorageService: LocalStorageManagerService) {
    const currentUserFromLocalStorage =
      JSON.parse(localStorage.getItem("currentUser")) || null;
    if (currentUserFromLocalStorage) {
      this.setUser(currentUserFromLocalStorage);
    }
    if (this.localStorageService.getItem("devToolsEnabled") === "true") {
      this.devToolsEnabled = true;
    }
    if (window && window.location.host.includes("local")) {
      this.isLocalHost = true;
    }
  }

  public get isDevOrStaging(): boolean {
    return environment.name === "dev" || environment.name === "staging";
  }

  public get features(): IFeatures {
    const features: IFeatures = {
      brothersAttributionPage: false,

      ForgotPasswordSendEmail: false,
      ModalWithBrotherAttributionAfterChildSave: false,
      collectiveRefund: false,
      CollectiveRefundSecondApproval: false,
      ShowGetPaymentsSummary: false,
      userManagementPage: false,
      newOpenReceiptPage: false,
      twoFactorLogin: false,
      twoFactorCodeCubes: false,
    };
    const featureFlagsFromEnv = environment.features || {};

    Object.keys(featureFlagsFromEnv).forEach((key) => {
      if (key in features) {
        features[key] = featureFlagsFromEnv[key];
      }
    });
    return features;
  }
  public isStagingDevModeActive() {
    return this.isDevOrStaging && this.devToolsEnabled;
  }

  public isDevModeActive() {
    return this.isLocalHost && this.devToolsEnabled;
  }

  public getUser() {
    return this._user;
  }

  public setUser(value: GenericUser | null) {
    this._user = value;
  }

  public getCurrentUserPermissions(): UserPermissions {
    return this.getUserPermissions(this._user);
  }

  public recordUserLoginTime() {
    const epochTime: number = new Date().getTime();
    this.localStorageService.setItem("last-login", epochTime.toString());
  }

  public getMinuetsFromLastLogin() {
    const epochTime: number = new Date().getTime();
    const lastLoginEpochTime = +(
      this.localStorageService.getItem("last-login") || epochTime
    );
    const millisecondsInMinuet = 60000;
    return (epochTime - lastLoginEpochTime) / millisecondsInMinuet;
  }

  public getUserPermissions(user: GenericUser): UserPermissions {
    return CalculateUSerPermissionFromUser(user);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/SessionManager/session-manager.service.ts